module.exports = __webpack_public_path__ + "img/stema.db5e42d3.jpeg";